import React, { useEffect, useState } from "react";
import { Container, Row, Col, Image } from "react-bootstrap";

function Mockuptwo() {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);


  const mockupImages = [
  { id: 1, url: "/assets/k1.PNG", alt: "Mockup 1" },
  { id: 2, url: "/assets/shirt.png", alt: "Mockup 2" },
  { id: 3, url: "/assets/k2.PNG", alt: "Mockup 3" },
 
];


  return (
    <Container
      fluid
      className="container-section"
      style={{
        backgroundColor: "#212020",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: isSmallScreen ? "auto" : "100vh",
        paddingBottom: isSmallScreen ? "2rem" : "0rem",
       
      }}
    >
      <Row
        className="justify-content-center "
        style={{ textAlign: "center", rowGap: isSmallScreen ? "2rem" : "0", width:"100%"  }}
      >
     {mockupImages.map((image) => (
          <Col
            xs={12}
            md={4}
            lg={4}
            key={image.id}
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Image
              src={image.url}
              alt={image.alt}
              style={{
                maxWidth: "100%",
                height: "auto",
                borderRadius: "9px",
              }}
            />
          </Col>
        ))}
      </Row>
    </Container>
  );
}

export default Mockuptwo;
